import React from 'react';
import { ExternalLink } from 'lucide-react';
import SpotifyIcon from '../spotify/SpotifyIcon';

function spotifyOpenUrl(uri) {
  if (!uri || typeof uri !== 'string') return 'https://open.spotify.com';
  if (uri.startsWith('https://')) return uri;
  const match = uri.match(/^spotify:(track|album|playlist):([a-zA-Z0-9]+)$/);
  if (match) return `https://open.spotify.com/${match[1]}/${match[2]}`;
  return 'https://open.spotify.com';
}

const SpotifyCard = ({ metadata, isOwn = false }) => {
  const trackName = metadata?.track_name || 'Unknown track';
  const artist = metadata?.artist || '';
  const album = metadata?.album || '';
  const art = metadata?.album_art_url;
  const href = spotifyOpenUrl(metadata?.spotify_uri);

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={`flex items-center gap-3 rounded-xl p-2.5 min-w-[220px] max-w-[280px] transition-opacity hover:opacity-95 ${
        isOwn
          ? 'bg-white/15 text-white'
          : 'bg-white dark:bg-secondary-800 text-secondary-900 dark:text-secondary-100 border border-secondary-200/80 dark:border-secondary-600'
      }`}
      data-testid="chat-spotify-card"
    >
      <div className="h-12 w-12 rounded-lg overflow-hidden flex-shrink-0 bg-secondary-200 dark:bg-secondary-700">
        {art ? (
          <img src={art} alt="" className="h-full w-full object-cover" />
        ) : (
          <div className="h-full w-full flex items-center justify-center bg-[#1DB954]/20">
            <SpotifyIcon className="h-6 w-6 text-[#1DB954]" />
          </div>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold truncate leading-tight">{trackName}</p>
        {artist && (
          <p
            className={`text-xs truncate ${
              isOwn ? 'text-white/80' : 'text-secondary-500 dark:text-secondary-400'
            }`}
          >
            {artist}
          </p>
        )}
        {album && (
          <p
            className={`text-[10px] truncate mt-0.5 ${
              isOwn ? 'text-white/60' : 'text-secondary-400'
            }`}
          >
            {album}
          </p>
        )}
        <span
          className={`inline-flex items-center gap-1 mt-1 text-[10px] font-medium ${
            isOwn ? 'text-white/90' : 'text-[#1DB954]'
          }`}
        >
          <SpotifyIcon className="h-3 w-3" />
          Open in Spotify
          <ExternalLink className="h-2.5 w-2.5" />
        </span>
      </div>
    </a>
  );
};

export default SpotifyCard;
